import { Link } from "@StarberryUtils";
import * as React from "react"
import { Button, Container, Row, Col, Accordion, Card, useAccordionToggle } from "react-bootstrap"
//import ScrollAnimation from "react-animate-on-scroll";
import HTMLReactParser from 'html-react-parser';
import Slider from "react-slick";
import { useContext } from "react";
import {DotIcon} from "../../Icons/Icons";
import "./Milestones.scss";

// markup
const Milestones = (props) => { 
    return (
        <React.Fragment>
            <section className="section-story-timeline-wrap sec-pdy-120">
                <div className="milestones-list">
                    <Container>
                        <Row>
                            <Col xl={12}>
                                    <ul>
                                        <span className="dots-top dots d-none d-lg-flex"><DotIcon /></span>
                                        <span className="timeline-line d-none d-lg-flex"></span>
                                        {props.Milestone_details.map((mile, k) => {
                                            if (k % 2 == 0) {
                                                return (
                                                        <li className="list-item-wrap">
                                                            <h4 className="list-title-odd list-item-title text-uppercase">{mile.Title}</h4>
                                                            <div className="list-item d-flex list-item-odd">
                                                                <div className="info">
                                                                    <p className="list-desc d-block d-xl-block text-sm">{mile.Description}</p>
                                                                </div>
                                                            </div>
                                                        </li>
                                                )
                                            } else {
                                                return (

                                                    <li className="list-item-wrap">
                                                        <h4 className="list-title-even list-item-title text-uppercase">{mile.Title}</h4>
                                                        <div className="list-item d-flex list-item-even">
                                                        <div className="info">
                                                        <p className="list-desc d-block d-xl-block text-sm">{mile.Description}</p>
                                                        </div>
                                                        </div>
                                                    </li>
                                                    )
                                            }

                                        })}
                                        <span className="d-none d-lg-flex dots dots-bottom"><DotIcon /></span>
                                    </ul>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </React.Fragment>
    )
}
export default Milestones